import { render, staticRenderFns } from "./TileDataOMLogistics.vue?vue&type=template&id=5a1b5b92&"
import script from "./TileDataOMLogistics.vue?vue&type=script&lang=js&"
export * from "./TileDataOMLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports